import React from 'react';
import {Box, Button, Dialog, DialogActions, DialogContent, DialogTitle} from '@mui/material';
import {useTranslation} from 'react-i18next';

interface ConfirmDeleteActionDialogProps {
    open: boolean;
    message: string;
    onClose: () => void;
    onNo: () => void;
    onYes: () => void;
}

const ConfirmDeleteActionDialog: React.FC<ConfirmDeleteActionDialogProps> = ({
                                                                                 open,
                                                                                 message,
                                                                                 onClose,
                                                                                 onNo,
                                                                                 onYes
                                                                             }) => {
    const {t} = useTranslation();
    return (
        <Dialog
            open={open}
            onClose={() => {
            }}
            aria-describedby="alert-dialog-description"
            aria-labelledby="alert-dialog-title"
            disableScrollLock
            disablePortal
            disableEnforceFocus
            disableAutoFocus
            disableEscapeKeyDown
            maxWidth="xs"
            fullWidth
        >
            <DialogTitle id="alert-dialog-title">{t('common.confirm.title')}</DialogTitle>
            <DialogContent>
                <Box id="alert-dialog-description" sx={{pt: 1}}>
                    {message}
                </Box>
            </DialogContent>
            <DialogActions>
                <Button onClick={onNo} color="inherit" autoFocus>
                    {t('common.actions.no')}
                </Button>
                <Button onClick={onYes} variant="contained" color="error">
                    {t('common.actions.yes')}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ConfirmDeleteActionDialog;
